import { render, staticRenderFns } from "./UserDetailCommonTab.vue?vue&type=template&id=2f7d7af4&scoped=true&lang=pug&"
import script from "./UserDetailCommonTab.vue?vue&type=script&lang=js&"
export * from "./UserDetailCommonTab.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailCommonTab.vue?vue&type=style&index=0&id=2f7d7af4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7d7af4",
  null
  
)

export default component.exports